import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule, FlexModule } from '@angular/flex-layout';
import { MatListModule } from '@angular/material/list';

import { DhdListTileComponent } from './dhd-list-tile.component';

@NgModule({
  imports: [
    CommonModule,
    MatListModule,
    FlexLayoutModule,
    FlexModule,
  ],
  declarations: [DhdListTileComponent],
  exports: [DhdListTileComponent]
})
export class DhdListTileModule { }
